import { render, staticRenderFns } from "./AddHosehold.vue?vue&type=template&id=53da39fa&"
import script from "./AddHosehold.vue?vue&type=script&lang=js&"
export * from "./AddHosehold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports